import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-table-pagination',
  providers: [NgbPaginationConfig],
  templateUrl: './table-pagination.component.html',
  styleUrls: ['./table-pagination.component.css'],
})
export class TablePaginationComponent implements OnChanges {
  pgConfig: any;
  pgSize = '';
  maxSize = 4;
  boundaryLinks = true;
  rotate = true;
  ellipses = true;
  pageLimitOptions = [5, 10, 20, 50, 100];
  pageChangeSizeLabel = 'Change Page Size';
  @Input() page: number;
  @Input() perPage: number;
  @Input() totalPages: number;
  @Input() perPageValue: any;
  @Input() collectionSize: number;
  @Input() hideLimitDropdown: boolean;
  @Input() smallerSize = false;
  @Input() restrictAllOption = false;
  @Input() largeLimitOptions = false;
  @Input() xlargeLimitOptions = false;
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() perPageValueChange: EventEmitter<number | ''> = new EventEmitter<number | ''>();

  constructor(config: NgbPaginationConfig) {
    this.pgConfig = config;
    this.setPgConfig();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.smallerSize === true) {
      this.pageChangeSizeLabel = 'Page Size';
    }
    if (this.largeLimitOptions) {
      this.pageLimitOptions = [20, 100, 500, 1000];
    }
    if (this.xlargeLimitOptions) {
      this.pageLimitOptions = [100, 500, 1000];
    }
  }

  onPageChange(e: number): void {
    this.pageChange.emit(e);
  }

  selectPaginationLimit(limit: number | ''): void {
    this.perPageValueChange.emit(limit);
  }

  @HostListener('window:load', ['$event'])
  onPageLoad(event) {
    this.checkPaginationSize(event.currentTarget.outerWidth);
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkPaginationSize(event.srcElement.outerWidth);
  }

  checkPaginationSize(windowWidth: number) {
    if (windowWidth >= 653 && this.smallerSize !== true) {
      this.pgSize = '';
      this.maxSize = 4;
      this.pageChangeSizeLabel = 'Change Page Size';
      this.boundaryLinks = true;
      this.ellipses = true;
      this.rotate = true;
    }
    if (windowWidth < 653 || this.smallerSize === true) {
      this.pgSize = 'sm';
      this.maxSize = 3;
      this.pageChangeSizeLabel = 'Page Size';
      this.boundaryLinks = false;
      this.ellipses = false;
      this.rotate = false;
    }

    this.setPgConfig();
  }

  setPgConfig() {
    this.pgConfig.size = this.pgSize;
    this.pgConfig.maxSize = this.maxSize;
    this.pgConfig.boundaryLinks = this.boundaryLinks;
    this.pgConfig.rotate = this.rotate;
    this.pgConfig.ellipses = this.ellipses;
  }
}
